export const RecurringExpenseSort = {
  Amount: "amount",
  DueDate: "dueDate",
} as const;
export type RecurringExpenseSort =
  (typeof RecurringExpenseSort)[keyof typeof RecurringExpenseSort];

export const SORT_LABELS: Record<RecurringExpenseSort, string> = {
  amount: "Amount",
  dueDate: "Due Date",
};
